<template>
  <div>
    <div class="bottom-option-center-box">
      <div class="bottom-option-center" @click="toggleAutoView" ref="bottomOption">
<!--        <div class="bottom-option-center">-->
        <div class="bottom-option-center-hover"></div>
        <div class="bottom-option-text">
          {{ autoView ? "停止" : "360°环顾" }}
        </div>
      </div>
      <div class="bottom-option-top" @click="goHead" ></div>
      <div class="bottom-option-bottom" @click="goPanoBack"></div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import sceneData from "../utils/sceneData";
import {gzwInfo, giveThumbsUp, cityInfo} from "../utils/tools";

export default {
  props: {
    krpano: "",
  },
  data() {
    return {
      shareShow: false,
      uiShowOrHide: true,
      autoView: false,
      timeLine: "",
      audio: "",
      musicPlay: true,
      zanNum: "",
      numShow: false,
    };
  },
  methods: {
    ...mapMutations('common', ['SET_CLICKED_MAPLIST']),
      giveThumbsUpView() {
          let scene_name = this.krpano.get("xml.scene");
          let zone = scene_name.split("_")[1];
          let sceneShortName = scene_name.split("_")[1] + "_" + scene_name.split("_")[2]
          if("1" == zone){//央企展区投票
              let activeEnterprise = gzwInfo.filter(item => item.sceneName == sceneShortName)[0]
              giveThumbsUp(15982, activeEnterprise.groupId, activeEnterprise.id)
          }else if ("2" == zone){//地方展区投票
              let activeCity = cityInfo.filter(item => item.sceneName == sceneShortName)[0]
              giveThumbsUp(15982, activeCity.groupId, activeCity.id)
          }else {//序厅为央企展区随机投票
              const random = (min, max) => Math.floor(Math.random() * (max - min) + min); //随机数方法
              let index = random(0, gzwInfo.length); //生成一个从最小值为0 最大值为数组长度的随机数
              giveThumbsUp(15982, gzwInfo[index].groupId, gzwInfo[index].id)//随机给央企展区投票
          }

      },
    // 前进
    goHead() {
      var sceneIndex = this.krpano.get("scene[get(xml.scene)].index");
      sceneIndex++;
      if (sceneIndex >= this.krpano.get("scene.count")) {
        sceneIndex = 0;
      }
      var newSceneName = this.krpano.get("scene[" + sceneIndex + "].name");
      // 数据插入clickedMapList
      this['SET_CLICKED_MAPLIST'](newSceneName)
      this.krpano.call(
        "loadscene(" +
        newSceneName +
        ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
      );
        // this.giveThumbsUpView();
    },
    // 后退
    goPanoBack() {
      var sceneIndex = this.krpano.get("scene[get(xml.scene)].index");
      sceneIndex--;
      if (sceneIndex < 0) {
        sceneIndex = this.krpano.get("scene.count") - 1;
      }
      var newSceneName = this.krpano.get("scene[" + sceneIndex + "].name");
      // 数据插入clickedMapList
      this['SET_CLICKED_MAPLIST'](newSceneName)
      this.krpano.call(
        "loadscene(" +
        newSceneName +
        ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
      );
        // this.giveThumbsUpView();
    },
    // 点蜡烛
    candleClick() {
      this.$emit("candleClick");
    },



    // 自动巡游
    toggleAutoView() {
      this.autoView = !this.autoView;

      if (this.autoView) {
        this.krpano.set("autorotate.enabled", true);
        this.bombtimer(0);
      } else {
        clearInterval(this.timerLine);
        this.krpano.set("autorotate.enabled", "false");
      }
    },
    bombtimer(timer) {
        var that = this;
        var rotateState = this.krpano.get("autorotate.enabled");
        if (rotateState) {
            this.autoView = true;
            timer++;
       
            this.timeLine = setTimeout(function () {
                that.bombtimer(timer);
            }, 1000);

            var rotateSpeed = Math.abs(this.krpano.get("autorotate.speed"));
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
            var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
            var isIE11 = userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
            if (isIE) {
                if (isIE11 || isEdge) {
                    rotateSpeed = 10;
                }
            }

            var timeAll = 350 / rotateSpeed;
            timeAll += this.krpano.get("autorotate.waittime");
            if (timer >= timeAll) {
                timer = 0;
           
                this.nextscene();
            }
        }
    },
    nextscene() {
      var nowSceneName = this.krpano.get("xml.scene");
      var sceneIndex = this.getIndex(nowSceneName, sceneData);
      sceneIndex++;
      if (sceneIndex >= sceneData.length) {
        sceneIndex = 0;
      }
      this.krpano.call(
        "loadscene(" +
        sceneData[sceneIndex] +
        ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
      );
    },
    getIndex(indexName, nameArr) {
      for (var i = 0; i < nameArr.length; i++) {
        if (indexName === nameArr[i]) {
          return i;
        }
      }
    },
    // 自动巡游end


  },
  mounted() {
    let _this = this;

    document.addEventListener("click", function (e) {
      if (_this.$refs.bottomOption) {
        let isSelf = _this.$refs.bottomOption.contains(e.target)
        if (!isSelf) {
          _this.autoView = false
          _this.timerLine && clearInterval(_this.timerLine);
          _this.krpano.set("autorotate.enabled", "false");
        }
      }
    })

      window["nav_front"] = this.goHead;
      window["nav_behind"] = this.goPanoBack;


 
  },
};
</script>

<style lang="scss" scoped>
@mixin background-com {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.bottom-option-center-box {
  width: 244px;
  height: 244px;
  @include background-com();
  // background-image: url("../assets/img/bottom-option-bg.png");
  background-image: url("../assets/img/center-btn/center-btn-bg.png");
  position: absolute;
  bottom: 66px;
  left: 50%;
  margin-left: -122px;
  text-align: center;

  .bottom-option-center {
    width: 100px;
    height: 100px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;
    cursor: pointer;
    // background-image: url("../assets/img/option-center-bg.png");
    //background-image: url("../assets/img/center-btn/center-btn-anniu.png");
    @include background-com();

    .bottom-option-center-hover {
      width: 100px;
      height: 100px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -50px;
      margin-top: -50px;
      // background-image: url("../assets/img/option-center.png");
      //background-image: url("../assets/img/center-btn/center-btn-anniu.png");
      @include background-com();
    }

    &:hover {
      .bottom-option-center-hover {
        display: none;
      }
    }

    .bottom-option-text {
      font-size: 20px;
      color: #a21d10;
      font-weight: 700;
      text-align: center;
      width: 100%;
      height: 30px;
      line-height: 30px;
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -15px;
    }
  }

  .bottom-option-top {
    width: 50px;
    height: 28px;
    //background-image: url("../assets/img/option-top.png");
    @include background-com();
    position: absolute;
    left: 50%;
    margin-left: -24px;
    top: 32px;
    cursor: pointer;

    &:hover {
      background-image: url("../assets/img/option-top-hover.png");
    }
  }

  .bottom-option-bottom {
    width: 50px;
    height: 28px;
    //background-image: url("../assets/img/option-bottom.png");
    @include background-com();
    position: absolute;
    left: 50%;
    margin-left: -24px;
    bottom: 30px;
    cursor: pointer;

    &:hover {
      background-image: url("../assets/img/option-bottom-hover.png");
    }
  }
}

.bottom-item-text {
  text-align: center;
  font-size: 24px;
  color: #aa0000;
  position: absolute;
  bottom: 10p;
  left: 0;
  width: 100%;
  cursor: pointer;
}
</style>
